module.exports = __webpack_public_path__ + "img/04_FachmannTextilpflege_Foto.15031bf7.jpg";